import React from 'react';
import Loading from 'src/components/Loading';
import { observer } from 'src/utils/mobx-react';
import { LiabilitiesState } from 'src/domains/sportsbook/trading/view/Liabilities/Liabilities.state';
import { LiabilitiesListRow } from './LiabilitiesListRow';

interface PropsType {
    liabilitiesState: LiabilitiesState;
}

export const LiabilitiesList = observer('LiabilitiesList', (props: PropsType) => {
    const { liabilitiesState } = props;

    const { list, isLoading } = liabilitiesState;

    const elements = list.map((id: number) => {
        return (
            <LiabilitiesListRow
                key={id}
                eventId={id}
                liabilitiesState={liabilitiesState}
            />
        );
    });

    return (
        <div className='liabilities-events-list'>
            <table className='liabilities-events-list-table table__striped'>
                <tbody>{elements}</tbody>
            </table>
            <Loading
                active={isLoading}
                // label='Loading events...'
            />
        </div>
    );
});
